export enum JobAlertFrequencyEnum {
  Instantly = 'instantly',
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',

  // Only front value
  None = 'none',
}
